module.exports = __webpack_public_path__ + "9adb6339cc1b10e6b2e5c44c951f3d5b.png";